import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AnalyticsDirective } from 'src/app/directives/analytics.directive';
import { UserAuthService } from 'src/app/state/user-auth/user-auth.service';

@Component({
    imports: [
        AnalyticsDirective,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
    ],
    selector: 'rdx-signup-component',
    standalone: true,
    styleUrls: ['./signup.component.scss'],
    templateUrl: './signup.component.html',
})
export class SignupComponent {
    // TODO: CLI - ensure all references to navigateTo are URLs (not state) and get rid of navigateParams
    @Input() navigateTo: string;

    userEmail?: string;

    constructor(private userAuthService: UserAuthService) {}

    onSignupClicked() {
        this.userAuthService.logIn(this.userEmail, this.navigateTo, 'signUp');
    }

    onSigninClicked() {
        this.userAuthService.logIn(this.userEmail, this.navigateTo);
    }
}
